import { ActionType, getType } from 'typesafe-actions';

import * as buffer from '../../actionCreators/buffer';

const initialState = null;

export default function (
  state: CreditCardPaymentInformation | null = initialState,
  action: ActionType<typeof buffer>,
): CreditCardPaymentInformation | null {
  switch (action.type) {
    case getType(buffer.clearBuffer): {
      return initialState;
    }
    case getType(buffer.setBufferCreditCardPaymentInformation): {
      const { value } = action.payload;
      return value || initialState;
    }
    default:
      return state;
  }
}
